
import { defineComponent, type PropType } from 'vue'

import IssueDetailMixin from '~/mixins/issueDetailMixin'

import { getSilenceRuleError, UiIssueLevel } from '~/utils/issue'

export default defineComponent({
  name: 'IgnoreIssueOccurrence',
  mixins: [IssueDetailMixin],
  emits: ['close', 'ignoreForever'],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    filePath: {
      type: String,
      required: true
    },
    checkId: {
      type: String,
      required: false
    },
    shortcode: {
      type: String,
      required: false
    },
    issueLevel: {
      type: String as PropType<UiIssueLevel>,
      default: UiIssueLevel.Check
    },
    repositoryId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    UiIssueLevel() {
      return UiIssueLevel
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {
        filePath: this.filePath
      } as {
        repositoryId?: string
        checkId?: string
        filePath: string
        issueShortcode?: string
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueForFile(params)

        this.$toast.success(
          `Ignored all occurrences of ${this.issueShortcode} for ${params.filePath}.`
        )
        this.$emit('ignoreForever', response.checkIssueIds)
      } catch (e) {
        const silenceRuleMsg = getSilenceRuleError(e)
        if (silenceRuleMsg) {
          this.$toast.danger(silenceRuleMsg)
        } else {
          this.$logErrorAndToast(
            e as Error,
            'Something went wrong while ignoring this issue, please contact support.',
            undefined,
            {
              context: 'Ignore Issue',
              params: {
                method: 'Ignore Issue Occurence for Single File',
                ...params
              }
            }
          )
        }
      } finally {
        this.isLoading = false
      }
    }
  }
})
